import { ReaderBlockFileContent } from '.';

import type { CommonBlockPropsReader } from 'components/reader/blocks';

const ReaderBlockFile = ({
  data,
  font,
  fontSize
}: CommonBlockPropsReader<'file'>) => {
  return data.file ? (
    <div className="file">
      <ReaderBlockFileContent
        fileUrl={data.file.url}
        font={font}
        fontSize={fontSize}
        title={
          data.title || data.file.url?.slice(data.file.url.lastIndexOf('/') + 1)
        }
      />

      <style jsx>{`
        .file {
          text-align: center;
        }
      `}</style>
    </div>
  ) : null;
};

export default ReaderBlockFile;
